import { render } from "./payment-success.vue?vue&type=template&id=151a43b1"
import script from "./payment-success.vue?vue&type=script&lang=js"
export * from "./payment-success.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__